import { TranslationKeys } from '~/common/types';
import { ISegmentName } from '~/common/types';

export const SEGMENT_NAME: { [Key in ISegmentName]: keyof TranslationKeys } = {
  BUDGET: 'segment.budget',
  QUALITY: 'segment.quality',
  PREMIUM: 'segment.premium',
};
